import Typography from "@mui/material/Typography";
import { ContentContainer } from "components/ContentContainer";
import { AdultService } from "./AdultsService";
import { ChildrenService } from "./ChildrenService";

export function Content2() {
  return (
    <ContentContainer backgroundColor="primary">
      <Typography variant="h2" fontWeight={"medium"}>
        Diagnoza i terapia logopedyczna oraz neurologopedyczna dzieci, młodzieży
        oraz osób dorosłych
      </Typography>
      <ChildrenService />
      <AdultService />
    </ContentContainer>
  );
}
